import React from "react";
import { Badge } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
export default function FareCalendarBadge({ currencyCode, className }) {
    const i18n = useI18n();
    return (React.createElement(Badge, { text: i18n.trans(t("flights_fare_cal_price_estimated", { variables: { currency_abbrev: currencyCode } })), alternative: true, className: className }));
}
